<script setup lang="ts">
import type { CustomFieldDefinition, Response } from '@/models/api-generated'
import { type CustomValueMap, fetchCustomValues } from '@/services/custom'
import http from '@/services/http'
import { ref, onMounted } from 'vue'
import CustomValueDisplay from '../custom_field/CustomValueDisplay.vue'

const props = defineProps<{ bpId: number }>()
const custom = ref<CustomFieldDefinition[]>([])
const customValues = ref<CustomValueMap>()

async function getCustomFields() {
	const { data } = await http.get<Response<CustomFieldDefinition[]>>(`api/customFields/business_processes`)
	if (data.data?.length) {
		custom.value.push(...data.data)
		customValues.value = await fetchCustomValues('business_processes', props.bpId)
	}
}

onMounted(getCustomFields)
</script>

<template v-if="custom.length">
	<hr class="mt-2 mb-2 border-1" />
	<div class="row" v-for="cf in custom" :key="cf.id">
		<div class="col">
			<b>{{ cf.label }}</b>
		</div>
		<div class="col" v-if="customValues">
			<CustomValueDisplay :field="cf" :value="customValues[cf.id][props.bpId]" />
		</div>
	</div>
</template>
